import { normalizeLossesVendor } from '../../../../Constants';
import { useOneButtonStore } from '../../../../store/oneButtonStore';

export function lossesSourceForVendor(vendor: string): 'EnFin' | 'oneDRAW' {
    return normalizeLossesVendor(vendor) === 'EnFin' ? 'EnFin' : 'oneDRAW';
}

export function persistLossesSource(vendor: string): void {
    const current = useOneButtonStore.getState().systemDesignLosses;
    useOneButtonStore.getState().setSystemDesignLosses({
        ...(current ?? {}),
        LossesSource: lossesSourceForVendor(vendor),
    });
}
